import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { AgentProfileItem } from "../types/agent-profile-types";
import { localeMapToBackend } from "../utils/locale-utils";
import { useStyles } from "./styles/basic-info.styles";

type BasicInfoProps = {
  agentProfile: AgentProfileItem;
};

const BasicInfo: FC<BasicInfoProps> = ({ agentProfile }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const mappedLocale = localeMapToBackend[currentLang] || currentLang;

  const { lbuName, designation, license, yearOfExperience, numberOfServicedCustomer } =
    agentProfile.agentDetail;

  const getDisplayServicedCustomer = () => {
    if (!numberOfServicedCustomer || numberOfServicedCustomer < 50) {
      return;
    } else if (numberOfServicedCustomer < 100) {
      return 50;
    } else if (numberOfServicedCustomer < 200) {
      return 100;
    } else if (numberOfServicedCustomer < 300) {
      return 200;
    } else if (numberOfServicedCustomer < 500) {
      return 300;
    }
    return 500;
  };

  const getAgentIntroduction = () => {
    const key = "agentProfile.pp_agent_introduction";
    const year = Math.trunc(Number(yearOfExperience || 0) / 5) * 5;
    const num3 = getDisplayServicedCustomer();
    const params = {
      num1: license.gi === "Y" ? t(key + "_num1") : "",
      num2: year >= 5 ? t(key + "_num2", { num: year }) : "",
      num3: num3 ? t(key + "_num3", { num: num3 }) : "",
    };
    return t("agentProfile.pp_agent_introduction", params);
  };

  const getServiceScope = () => {
    const str = currentLang === "en" ? ", " : "、";
    const key = "agentProfile.pp_service_scope";
    const params = {
      num1: license.inv_link ? str + t(key + "_num1") : "",
      num2: license.gi === "Y" ? str + t(key + "_num2") : "",
      num3: license.mpf ? str + t(key + "_num3") : "",
    };
    return t(key, params);
  };

  return (
    <>
      <div className={classes.agentNameStyle}>{agentProfile.name[mappedLocale]}</div>
      <div className={classes.informationContainer}>
        {agentProfile.achievements && agentProfile.achievements.length !== 0 && (
          <div className={classes.informationContentStyle}>
            {agentProfile.achievements.join(", ")}
          </div>
        )}
        {designation[mappedLocale] && (
          <div className={classes.informationContentStyle}>{designation[mappedLocale]}</div>
        )}
        {/*{lbuName && lbuName[mappedLocale] && (
          <div className={classes.informationContentStyle}>{lbuName[mappedLocale]}</div>
        )}
        {license.gi === "Y" && (
          <div className={classes.informationContentStyle}>{t("agentProfile.pp_pgihk_label")}</div>
        )} */}
        <div className={classes.informationContentStyle}>{getAgentIntroduction()}</div>
        <div className={classes.informationContentStyle}>{getServiceScope()}</div>
        {license.hkfi && (
          <div className={classes.informationContentStyle}>
            {t("agentProfile.pp_ia_license_label")}: {license.hkfi}
          </div>
        )}
        {license.mpf && (
          <div className={classes.informationContentStyle}>
            {t("agentProfile.pp_mpf_license_label")}: {license.mpf}
          </div>
        )}
        {license.sfc && (
          <div className={classes.informationContentStyle}>
            {t("agentProfile.pp_sfc_license_label")}: {license.sfc}
            <br />
            {t("agentProfile.pp_sfc_license_statement")}
          </div>
        )}
      </div>
    </>
  );
};

export default BasicInfo;
